import { FormGroup, FormControl, Validators } from '@angular/forms';
import { Row } from './row';
import { Column } from './column';
import { ValidatorService } from '../validator.service';

export class DataSet {
  public newRow: Row;

  public newRowValidator: FormGroup;
  public editRowValidators: FormGroup[];
  protected data: any[] = [];
  protected columns: Column[] = [];
  protected rows: Row[] = [];
  protected selectedRow: Row;
  protected willSelect: string = 'first';

  constructor(
    data: any[] = [],
    protected columnSettings: any,
    private validator: ValidatorService
  ) {
    this.createColumns(columnSettings);
    this.setData(data, '', false);
    this.createNewRow();
  }

  public addDefaultsToFormGroup(formGroup: FormGroup): FormGroup {
    // if (this.columnSettings)
    //   for (const id in this.columnSettings) {
    //     if (!formGroup.controls[id] && this.columnSettings.hasOwnProperty(id))
    //       formGroup.controls[id] = new FormControl();
    //   }
    // return formGroup;
    let group: any = {};
    if (this.columnSettings) {
      for (const id in this.columnSettings) {
        // have to set custom validators for every field which we get from column settings.
        // also have to take care of messages which will be displayed on row being invalid.
        if (this.columnSettings.hasOwnProperty(id)) {
          group[id] = new FormControl(
            { value: '', disabled: this.columnSettings[id].disabled },
            this.columnSettings[id].validators
          );
        }
      }
    }
    group['uid'] = new FormControl({ value: 0, disabled: true });
    return new FormGroup(group);
  }

  public createNewRowValidator() {
    let validator = this.addDefaultsToFormGroup(this.validator.getFormGroup());
    return validator;
  }

  public createValidators(columnSettings: object) {
    let rows: Row[] = this.getRows();
    this.editRowValidators = new Array<FormGroup>();
    this.data.forEach((data, index) => {
      let formGroup = this.addDefaultsToFormGroup(
        this.validator.getFormGroup()
      );
      formGroup.controls['uid'].setValue(data.uid);
      this.editRowValidators.push(formGroup);
    });
  }
  public initializeValidators() {
    let rows: Row[] = this.getRows();
    if (this.editRowValidators.length > 0) {
      this.editRowValidators.forEach((item, index) => {
        for (const id in this.columnSettings) {
          if (this.columnSettings.hasOwnProperty(id)) {
            item.controls[id].setValue(
              rows[index].getCellByColumnId(id).getInitialValue()
            );
          }
        }
      });
    }
  }

  public setData(
    data: any[],
    event: string,
    newRow: boolean,
    newRowRemoved?: boolean
  ) {
    // 1)if a new row is added we create a new validator and push it
    // to existing validators array
    // 2) if a new row is removed we dont create validators again,
    // corresponding validator gets removed in grid.ts
    // 3) if an old row is removed we create all validators again as the source gets
    // updated with latest values from backend
    this.data = data;
    if (this.data.length > 0) {
      this.createRows();
      if (newRow === undefined) {
        this.createValidators(this.columnSettings);
        this.initializeValidators();
      } else {
        if (newRow) {
          if (this.editRowValidators.length > 0) {
            let validator = this.createNewRowValidator();
            validator.controls['uid'].setValue(data[0].uid);
            this.editRowValidators.unshift(validator);
          } else {
            this.createValidators(this.columnSettings);
            this.initializeValidators();
          }
        } else {
          if (data.length === 25 && !newRowRemoved) {
            this.createValidators(this.columnSettings);
            this.initializeValidators();
          }
        }
      }
    } else {
      this.rows = [];
      this.editRowValidators = new Array<FormGroup>();
    }
  }

  public getColumns(): Column[] {
    return this.columns;
  }

  public getRows(): Row[] {
    return this.rows;
  }

  public getFirstRow(): Row {
    return this.rows[0];
  }

  public getLastRow(): Row {
    return this.rows[this.rows.length - 1];
  }

  public getRowValidator(index: number, uid?: number): FormGroup {
    if (index === -1) {
      return this.newRowValidator;
    } else {
      let vindex = this.editRowValidators.findIndex((validator) => {
        if (validator.controls['uid'].value === uid) {
          return true;
        }
      });
      if (vindex !== -1) {
        return this.editRowValidators[vindex] as FormGroup;
      }
    }
  }
  public getValidators(): FormGroup[] {
    return this.editRowValidators;
  }
  public findRowByData(data: any): Row {
    return this.rows.find((row: Row) => row.getData().uid === data.uid);
  }

  public deselectAll() {
    this.rows.forEach((row) => {
      row.isSelected = false;
    });
  }

  public selectRow(row: Row): Row {
    const previousIsSelected = row.isSelected;
    this.deselectAll();

    row.isSelected = !previousIsSelected;
    this.selectedRow = row;

    return this.selectedRow;
  }

  public multipleSelectRow(row: Row): Row {
    // row.isSelected = !row.isSelected;
    this.selectedRow = row;

    return this.selectedRow;
  }

  public selectPreviousRow(): Row {
    if (this.rows.length > 0) {
      let index = this.selectedRow ? this.selectedRow.index : 0;
      if (index > this.rows.length - 1) {
        index = this.rows.length - 1;
      }
      this.selectRow(this.rows[index]);
      return this.selectedRow;
    }
  }

  public selectFirstRow(): Row {
    if (this.rows.length > 0) {
      this.selectRow(this.rows[0]);
      return this.selectedRow;
    }
  }

  public selectLastRow(): Row {
    if (this.rows.length > 0) {
      this.selectRow(this.rows[this.rows.length - 1]);
      return this.selectedRow;
    }
  }

  public willSelectFirstRow() {
    this.willSelect = 'first';
  }

  public willSelectLastRow() {
    this.willSelect = 'last';
  }

  public select(): Row {
    if (this.getRows().length === 0) {
      return;
    }
    if (this.willSelect) {
      if (this.willSelect === 'first') {
        this.selectFirstRow();
      }
      if (this.willSelect === 'last') {
        this.selectLastRow();
      }
      this.willSelect = '';
    } else {
      this.selectFirstRow();
    }

    return this.selectedRow;
  }

  public addInsertedRowValidator(): void {
    this.newRowValidator.reset();
    this.editRowValidators = [
      this.addDefaultsToFormGroup(this.validator.getFormGroup())
    ].concat(this.editRowValidators);
  }

  public createNewRow() {
    this.newRow = new Row(0, {}, this, 'y');
    this.newRow.isInEditing = true;
  }

  /**
   * Create columns by mapping from the settings
   * @param settings
   * @private
   */
  public createColumns(settings: any) {
    for (const id in settings) {
      if (settings.hasOwnProperty(id)) {
        this.columns.push(new Column(id, settings[id], this));
      }
    }
  }

  /**
   * Create rows based on current data prepared in data source
   * @private
   */
  public createRows() {
    this.rows = [];
    this.data.forEach((el, index) => {
      this.rows.push(
        new Row(
          index,
          el,
          this,
          !el.hasOwnProperty('editable') ? 'y' : el.editable
        )
      );
    });
  }
}
